import React, { useContext, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import "./Faq.css";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { GetAllFAQ } from "../../features/website/Slice";
import { Context } from "../../../utils/context";

function Faq() {
  const dispatch = useDispatch();
  const faqData = useSelector(
    (state) => state?.website?.GetSuccessSpeaks?.all_faq,
  );

  const { language, setLanguage } = useContext(Context);

  console.log(faqData, "faqData");

  const loadFaq = async () => {
    await dispatch(GetAllFAQ({ language }));
  };

  useEffect(() => {
    loadFaq();
  }, [dispatch, language]);

  return (
    <>
      <section className="Faq">
        <div className="container">
          <div className="heading_text_holder">
            <h2>
              {language == 1 ? "Frequently" : "Fréquemment"}
              <br />
              {language == 1 ? "Asked Questions" : "Questions posées"}
            </h2>
          </div>

          <div className="Faq_accordians_holder">
            <div className="form_holder">
              <Form>
                <Accordion defaultActiveKey="0">
                  {faqData?.data?.map((value, index) => (
                    <Accordion.Item eventKey={index}>
                      <Accordion.Header>{value?.name}</Accordion.Header>
                      <Accordion.Body>
                        {/* Internships are typically short-term work experiences
                        (3-6 months) and can be part-time or full-time. Co-op
                        programs, on the other hand, are integrated into your
                        academic curriculum and are usually longer, lasting 6-12
                        months, often alternating with semesters of classroom
                        study. */}
                        {value?.description}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}

                  {/* <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      Can I apply for internships without any prior experience?
                    </Accordion.Header>
                    <Accordion.Body>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidatat non proident, sunt in culpa qui
                      officia deserunt mollit anim id est laborum.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      Is it possible to apply to more than one program or
                      internship simultaneously?
                    </Accordion.Header>
                    <Accordion.Body>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidatat non proident, sunt in culpa qui
                      officia deserunt mollit anim id est laborum.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      Can I combine an internship with a study abroad program?
                    </Accordion.Header>
                    <Accordion.Body>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidatat non proident, sunt in culpa qui
                      officia deserunt mollit anim id est laborum.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      What are the visa requirements for internships in France
                      or Mauritius?​
                    </Accordion.Header>
                    <Accordion.Body>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidatat non proident, sunt in culpa qui
                      officia deserunt mollit anim id est laborum.
                    </Accordion.Body>
                  </Accordion.Item> */}
                </Accordion>
              </Form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq;
